import _ from 'lodash'

export default ({ readingTypesData: { readingTypes }, name }) =>
  _.pick(_.find(readingTypes, { name }), 'id')
